import React from 'react'

export default ({ text, marginTop, miniText }) => (<span style={{ display: 'flex', }} ><p style={{ fontSize: 30, marginTop }} >{text}</p><p style={{ marginLeft: 10, fontSize: 30, marginTop, color: '#73d5d8' }} >{miniText ? "(" + miniText + ")" : null}</p></span>)


// WEBPACK FOOTER //
// ./src/components/Regular/Subtitle.js